import { PaymentOption, WashingOption } from "../../types/washing.types";

export enum PAGES {
  START_PAGE = 0,
  CHOOSE_LICENCE = 1,
  CHOOSE_WASHING = 2,
  WASHING_PAYMENT = 3,
  WASHING_PAYMENT_LOADING = 4,
  CHOOSE_TAX = 5,
  SEND_RECEIPT = 6,
  WASHING_PAYMENT_SUCCESS = 7,
  WASHING_PAYMENT_ERROR = 8,
  WASHING_PROCESS_ERROR = 9,
}

export enum PAYMENT_TYPES {
  CARD_DEBIT = "debito",
  CARD_CREDIT = "credito"
}

export interface WashingStoreInteraction {
  currPage: PAGES;
  selectedWashing: WashingOption;
  selectedPayment: PaymentOption;
  errorMsg: string;
  paymentId: string;
  cieloTransactionId: string;
  finalPrice: number;
  licencePlate?: string;
  taxId?: string;
}

export interface TotemWashingStoreState extends WashingStoreInteraction {
  washingOptions: WashingOption[];
  totemId: string;
  terminalId: string;
}
